import React from "react";
import { Outlet } from "react-router-dom";
import { Navbar } from "./Navbar";
import { Footer } from "./Footer";
import { WhatsAppFloat } from "./WhatsAppFloat";

export const Layout = () => (
  <div className="App min-h-screen bg-trise-ivory">
    <Navbar />
    <main>
      <Outlet />
    </main>
    <Footer />
    <WhatsAppFloat />
  </div>
);
